
import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FaImage, FaMapMarkedAlt, FaPhoneAlt, FaTrash } from 'react-icons/fa';
import { useSnackbar } from 'v3/components/Snackbar';

import {
  CNH_TYPES,
  HOME_TYPES,
  ADDRESS_TYPES,
  CIVIL_STATUS,
  CPF_MASK,
  PIS_MASK,
  PHONE_MASK,
  DATE_MASK
} from 'v3/utils/masks';
import { getPhoneMask } from 'v3/utils/functions';

import Input from 'v3/components/Input';
import Text from 'v3/components/Text';
import Radio from 'v3/components/Radio';
import Table from 'v3/components/Table';
import Button from 'v3/components/Button';
import Upload from 'v3/components/Upload';
import Select from 'v3/components/Select';
import DatePicker from 'v3/components/DatePicker';
import InputAddress from 'v3/components/InputAddress';
import ApplicationLayout from 'v3/layouts/Application';
import Tooltip from 'v3/components/Tooltip';
import Card, { DefaultLoadingBodyComponent } from 'v3/components/Card';
import { fetchCountries } from 'services/api/Locations';
import { BsCalendar } from 'react-icons/bs';
import Space from 'v3/components/Space';
import moment from 'moment';
import { isValid, isBefore, isAfter, parse, addYears } from 'date-fns';
import { cpf as cpfValidator } from 'cpf-cnpj-validator';
import api, { cooperplaceApi } from 'services/api';
import driverApi from 'services/apis/driver';
import { validatePermission } from 'actions/index';
import useModal from 'hooks/useModal';
import { formatDateTime } from 'v3/utils/formatter';
import { RegisterInfo } from 'v3/components/RegisterInfo';
import { DataTable } from 'v3/components';
import Resume from './Resume';
import Device from './Device';
import CnhData from './CnhData';
import Payment from './Payment';
import UserData from './UserData';
import RiskManager from './RiskManager';
import AddressData from './AddressData';
import LastTravels from './LastTravels';
import WorkJourney from './WorkJourney';
import PersonalData from './PersonalData';
import ContactDetails from './ContactDetails';
import PaymentCards from './PaymentCards';
import Vehicles from './Vehicles';
import EmergencyContact from './EmergencyContact';
import RiskManagerModal from './RiskManager/Modal';
import Verification from './Verification';
import RiskManagerLiberation from './RiskManager/Modal/Liberation';
import Attachments from './Attachments';

export default function DriverDetails() {
  const params = useParams();
  const riskManagerModal = useModal();
  const riskManagerLiberation = useModal();
  const dispatch = useDispatch();

  const snackbar = useSnackbar();

  const [loadingCard, setLoadingCard] = useState(true);

  const [driver, setDriver] = useState();
  const [lastTravels, setLastTravels] = useState();
  const [riskManagers, setRiskManagers] = useState();
  const [personalEditing, setPersonalEditing] = useState(false);
  const [cnhEditing, setCnhEditing] = useState(false);
  const [contactsEditing, setContactsEditing] = useState(false);
  const [addressEditing, setAddressEditing] = useState(false);
  const [loadPersonalEditing, setLoadPersonalEditing] = useState(false);
  const [loadCnhEditing, setLoadCnhEditing] = useState(false);
  const [loadContactsEditing, setLoadContactsEditing] = useState(false);
  const [loadAddressEditing, setLoadAddressEditing] = useState(false);
  const [vehicles, setVehicles] = useState([]);
  const [tagRegisterPermitted] = useState(validatePermission('CRIAR_TAGS'));

  const [errors, setErrors] = useState({});
  const [hasPermissionToEdit, setPermissionToEdit] = useState();
  const hasPermissionToCreate = validatePermission('CADASTRAR_MOTORISTAS');
  const navigate = useNavigate();
  useState(() => {
    setPermissionToEdit(validatePermission('ALTERAR_MOTORISTAS'));
  }, []);

  const [socialName, setSocialName] = useState('');
  const [cpf, setCpf] = useState('');
  const [birthdate, setBirthdate] = useState(null);
  const [birthCity, setBirthCity] = useState('');
  const [rg, setRg] = useState('');
  const [issuingBody, setIssuingBody] = useState('');
  const [issuingDate, setIssuingDate] = useState('');
  const [motherName, setMotherName] = useState('');
  const [fatherName, setFatherName] = useState('');
  const [pis, setPis] = useState('');
  const [isInternational, setIsInternational] = useState(false);
  const [civilStatus, setCivilStatus] = useState('');
  const [cnhNumber, setCnhNumber] = useState('');
  const [cnhType, setCnhType] = useState(null);
  const [cnhIssuingCity, setCnhIssuingCity] = useState('');
  const [firstCnhDate, setFirstCnhDate] = useState(null);
  const [cnhDispatchDate, setCnhDispatchDate] = useState(null);
  const [cnhDueDate, setCnhDueDate] = useState(null);
  const [hasMopp, setHasMopp] = useState(true);
  const [moppDescription, setMoppDescription] = useState('');
  const [moppDueDate, setMoppDueDate] = useState(null);
  const [moppInitialDate, setMoppInitialDate] = useState(null);
  const [frontImageCnh, setFrontImageCnh] = useState('');
  const [cnhKey, setCnhKey] = useState('');
  const [isExclusive, setIsExclusive] = useState(false);
  const [isAutonomous, setIsAutonomous] = useState(false);
  const [isOwner, setIsOwner] = useState(false);
  const [isCnhInternational, setIsCnhInternational] = useState(false);

  const [mainPhone, setMainPhone] = useState('');
  const [cooperplacePhone, setCooperplacePhone] = useState('');
  const [email, setEmail] = useState('');
  const [otherName, setOtherName] = useState('');
  const [otherPhone, setOtherPhone] = useState('');
  const [otherContacts, setOtherContacts] = useState([]);

  const [address, setAddress] = useState('');
  const [number, setNumber] = useState('');
  const [complement, setComplement] = useState('');
  const [neighborhood, setNeighborhood] = useState('');
  const [cep, setCep] = useState('');
  const [city, setCity] = useState('');
  const [homeType, setHomeType] = useState('');
  const [addressType, setAddressType] = useState('');
  const [numberless, setNumberless] = useState(false);
  const [ufName, setUfName] = useState('');
  const [uf, setUf] = useState('');
  const [countries, setCountries] = useState();
  const [country, setCountry] = useState();
  const [countriesDDI, setCountriesDDI] = useState();
  const [countryDDI, setCountryDDI] = useState();
  const [whatsAppLogs, setWhatasAppLogs] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [driverAttachments, setDriverAttachments] = useState([]);
  const [attachLoading, setAttachLoading] = useState(false);

  async function fetchAttachments() {
    try {
      setAttachLoading(true);
      const response = await api.get(`driver/${params.id}/attachments`);
      setAttachments(response.data.filter(attachment => !attachment.is_ocr_imported));
      setDriverAttachments(response.data.filter(attachment => attachment.is_ocr_imported === true));
    } catch (error) {
      //
    } finally {
      setAttachLoading(false);
    }
  }

  useEffect(() => {
    fetchCountries().then(setCountries);
    fetchAttachments();
    snackbar.show(
      <Text>
        Alterações de dados cadastrais devem ser solicitadas na viagem no card "Solicitação de
        Ajuste de Cadastro".
      </Text>,
      { type: 'warning' },
    );
  }, []);

  useEffect(() => {
    if (countries) {
      const formatCountryNamesWithDDI = (countries) => {
        return countries.map((value) => ({
          ...value,
          name: `${value.name} +${value.ddi}`,
        }));
      };
      const formattedCountries = formatCountryNamesWithDDI(countries);
      setCountriesDDI(formattedCountries);
    }
  }, [countries]);

  const [selectedTags, setSelectedTags] = useState('');
  const [provinces, setProvinces] = useState([]);

  async function getCountry(country_id) {
    try {
      const id = country_id ?? 1;
      const { data } = await api.get(`countries/${id}`);
      const c = Array.isArray(data) ? data[0] : data;
      if (c) setCountry(c);
    } catch (err) {
    }
  }

  async function getCountryDDI(country_id) {
    try {
      const id = country_id ?? 1;
      const { data } = await api.get(`countries/${id}`);
      const c = Array.isArray(data) ? data[0] : data;
      if (!c) return;

      const withDDI = { ...c, name: `${c.name} +${c.ddi}` };
      setCountryDDI(withDDI);

      setDriver(prev => (prev ? { ...prev, country_ddi: withDDI.name } : prev));
    } catch (err) {
    }
  }

  // ─── Validation helpers (same logic as Register/validator.js) ───────────────
  function validateDocument(document) {
    if (document) {
      return cpfValidator.isValid(document);
    }
    return true;
  }

  function whiteSpace(value) {
    if (value) {
      const onlySpace = value.replace(/\s/g, '');
      return !!onlySpace;
    }
    return true;
  }

  function validateDate(value) {
    if (value) {
      const [day, month, year] = value.split('/');
      if (!Number(year) && !Number(month) && !Number(day)) return false;
      const date = parse(
        `${Number(year)}-${Number(month)}-${Number(day)}`,
        'yyyy-MM-dd',
        new Date()
      );
      if (!isValid(date)) return false;
      return isBefore(date, new Date());
    }
    return true;
  }

  function validateFutureDate(value) {
    if (value) {
      const [day, month, year] = value.split('/');
      if (!Number(year) && !Number(month) && !Number(day)) return false;
      const date = parse(
        `${Number(year)}-${Number(month)}-${Number(day)}`,
        'yyyy-MM-dd',
        new Date()
      );
      if (!isValid(date)) return false;
      return isAfter(date, new Date());
    }
    return true;
  }

  function expireDate(value, time) {
    if (value) {
      const maxDate = addYears(new Date(), time);
      const [day, month, year] = value.split('/');
      if (!Number(year) && !Number(month) && !Number(day)) return false;
      const date = parse(
        `${Number(year)}-${Number(month)}-${Number(day)}`,
        'yyyy-MM-dd',
        new Date()
      );
      if (!date) return false;
      return isBefore(date, maxDate);
    }
    return true;
  }
  // ────────────────────────────────────────────────────────────────────────────

  function validatePersonalData() {
    const err = {};

    // Nome
    if (!socialName) {
      err.socialName = 'Campo obrigatório';
    } else if (!whiteSpace(socialName)) {
      err.socialName = 'Campo inválido';
    }

    // Cidade natal
    if (!birthCity) {
      err.birthCity = 'Campo obrigatório';
    }

    // CPF / Documento
    if (!cpf) {
      err.cpf = 'Campo obrigatório';
    } else if (!isInternational && !validateDocument(cpf)) {
      err.cpf = 'Documento inválido';
    }

    // Data de nascimento
    if (!birthdate) {
      err.birthdate = 'Campo obrigatório';
    } else if (!validateDate(birthdate)) {
      err.birthdate = 'Data inválida';
    }

    // RG
    if (!isInternational) {
      if (!rg) {
        err.rg = 'Campo obrigatório';
      } else if (!whiteSpace(rg)) {
        err.rg = 'Campo inválido';
      }
    } else if (rg && !whiteSpace(rg)) {
      err.rg = 'Campo inválido';
    }

    // Órgão emissor / UF
    if (!isInternational) {
      if (!issuingBody) {
        err.issuingBody = 'Campo obrigatório';
      } else if (!whiteSpace(issuingBody)) {
        err.issuingBody = 'Campo inválido';
      }
    } else if (issuingBody && !whiteSpace(issuingBody)) {
      err.issuingBody = 'Campo inválido';
    }

    // Data de emissão RG (opcional, valida se preenchido)
    if (issuingDate && !validateDate(issuingDate)) {
      err.issuingDate = 'Data inválida';
    }

    // Nome da mãe
    if (!motherName) {
      err.motherName = 'Campo obrigatório';
    } else if (!whiteSpace(motherName)) {
      err.motherName = 'Campo inválido';
    }

    // Nome do pai
    if (!fatherName) {
      err.fatherName = 'Campo obrigatório';
    } else if (!whiteSpace(fatherName)) {
      err.fatherName = 'Campo inválido';
    }

    // Estado civil
    if (!civilStatus) {
      err.civilStatus = 'Campo obrigatório';
    }

    // PIS (obrigatório quando autônomo)
    if (isAutonomous) {
      if (!pis) {
        err.pis = 'Campo obrigatório';
      } else if (!whiteSpace(pis)) {
        err.pis = 'Campo inválido';
      }
    } else if (pis && !whiteSpace(pis)) {
      err.pis = 'Campo inválido';
    }

    setErrors(err);
    return !Object.keys(err).length;
  }

  function fillEditValues(driver, currentEdit) {
    try {
      // ---> Personal Data <---
      setIsInternational(driver.is_international ? driver.is_international : false);
      setSocialName(driver.social_name);
      setCpf(driver.cgccpf);
      setBirthdate(
        driver.birthdate ? moment(driver.birthdate, 'YYYY-MM-DD').format('DD/MM/YYYY') : '',
      );
      setBirthCity(driver.born_city); // Objeto e precisa de async select
      setRg(driver.rg);
      setIssuingBody(driver.rg_emissor);
      setIssuingDate(
        driver.rg_dispatch_date
          ? moment(driver.rg_dispatch_date, 'YYYY-MM-DD').format('DD/MM/YYYY')
          : '',
      );
      setCivilStatus(
        driver.civilStatus
          ? { label: driver.civilStatus.name, value: driver.civilStatus.id }
          : null,
      );
      setMotherName(driver.mothers_name);
      setFatherName(driver.father_name);
      setPis(driver.pispasep);
      setSelectedTags(driver.driverTags || []);

      // ---> CNH <---
      setIsCnhInternational(driver.cnh_is_foreign ? driver.cnh_is_foreign : false);
      setCnhNumber(() => {
        if (driver?.cnh_number && driver?.cnh_number !== undefined) {
          return driver?.cnh_number?.match(/\d/g)?.join('');
        }
      });
      setCnhIssuingCity(driver.cnh_city); // Objeto e precisa de async select
      setCnhType({ label: driver.cnh_type });
      setFirstCnhDate(
        driver.first_cnh_date
          ? moment(driver.first_cnh_date, 'YYYY-MM-DD').format('DD/MM/YYYY')
          : '',
      );
      setCnhDispatchDate(
        driver.cnh_dispatch_date
          ? moment(driver.cnh_dispatch_date, 'YYYY-MM-DD').format('DD/MM/YYYY')
          : '',
      );
      setCnhDueDate(
        driver.cnh_exp_date ? moment(driver.cnh_exp_date, 'YYYY-MM-DD').format('DD/MM/YYYY') : '',
      );
      setCnhKey(driver.cnh_key);
      setMoppDescription(driver.mopp_description);
      setMoppDueDate(
        driver.mopp_expiration
          ? moment(driver.mopp_expiration, 'YYYY-MM-DD').format('DD/MM/YYYY')
          : '',
      );
      setMoppDueDate(
        driver.mopp_date_init
          ? moment(driver.mopp_date_init, 'YYYY-MM-DD').format('DD/MM/YYYY')
          : '',
      );
      setIsExclusive(!!driver.exclusive); // tratar no backend, caso enviar TRUE salvar company_id no lugar
      setIsAutonomous(driver.is_autonomous);
      setIsOwner(driver.is_owner);

      // ---> Contacts <---
      getCountryDDI(driver?.phone_cooperplace_country_id);
      setCooperplacePhone(driver.phone_cooperplace);
      setMainPhone(driver.phone);
      setEmail(driver.email);
      setOtherContacts(driver.phones || []);

      // ---> Address <---
      setAddress(driver.addresses[0]?.address || driver?.address_address);
      getCountry(driver.addresses[0]?.country_id || driver?.country_id);

      if (
        (driver.addresses[0]?.city_id &&
          driver.addresses[0]?.city_name &&
          driver.addresses[0]?.province_id &&
          driver.addresses[0]?.uf_name) ||
        (driver.address_city_id &&
          driver.address_city_name &&
          driver.address_city_province_id &&
          driver.address_province_uf)
      ) {
        setCity({
          id: driver.addresses[0]?.city_id || driver.address_city_id,
          name: driver.addresses[0]?.city_name || driver?.city_name,
          province: {
            id: driver.addresses[0]?.province_id || driver.address_city_province_id,
            uf: driver.addresses[0]?.uf_name || driver?.address_province_uf,
          },
        });
      }

      setUfName(driver.addresses[0]?.uf_name);
      if (driver.address_number || driver.addresses[0].number) {
        setNumberless(false);
      } else {
        setNumberless(true);
      }
      setNumber(driver.addresses[0]?.number || driver?.address_number || '');
      setComplement(driver.addresses[0]?.complement || driver?.address_complement);
      setNeighborhood(driver.addresses[0]?.neighborhood || driver?.address_neighborhood);
      setCep(driver.addresses[0]?.zip_code || driver?.address_zip_code);
      setHomeType({ label: driver.address_property_type || 'Outros' });
      setAddressType({ label: driver.address_property_status || 'Outros' });
    } catch (e) {
      // error
    } finally {
      switch (currentEdit) {
        case 'personal':
          setPersonalEditing(false);
          setLoadPersonalEditing(false);
          break;
        case 'cnh':
          setCnhEditing(false);
          setLoadCnhEditing(false);
          break;
        case 'contact':
          setContactsEditing(false);
          setLoadContactsEditing(false);
          break;
        case 'address':
          setAddressEditing(false);
          setLoadAddressEditing(false);
          break;
        default:
          break;
      }
    }
  }

  async function fetchWhatsAppLogs(personId) {
    const { data } = await cooperplaceApi.get('whatsapp_logs', {
      params: {
        perPage: 5,
        page: 1,
        personId,
      },
    });
    setWhatasAppLogs(data?.data);
  }

  async function getDriver(currentEdit = '') {
    const response = await api.get(`persons/${params.id}`);
    const dataDriver = response.data;
    setDriver(dataDriver);
    setVehicles(dataDriver.vehicles);
    fillEditValues(dataDriver, currentEdit);
    fetchWhatsAppLogs(dataDriver.id);
    setLoadingCard(false);
  }

  async function savePersonalData() {
    try {
      if (!validatePersonalData()) {
        snackbar.show(<Text>Verifique os campos obrigatórios!</Text>, {
          type: 'error',
        });
        return;
      }
      setLoadPersonalEditing(true);
      const bodyUpdatePersonal = {
        social_name: socialName.replace(/\s+/g, ' ').trim(),
        civil_state_id: civilStatus && civilStatus.value,
        cgccpf: cpf,
        birthdate: birthdate ? moment(birthdate, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
        born_city_id: birthCity && birthCity.id,
        born_province_id: birthCity && birthCity.province.id,
        rg,
        rg_emissor: issuingBody,
        rg_dispatch_date: issuingDate
          ? moment(issuingDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
          : null,
        mothers_name: motherName,
        father_name: fatherName,
        pispasep: pis,
        is_international: isInternational,
        selected_tags: selectedTags ? selectedTags.map((x) => x.id) : null,
      };

      const res = await api.put(`driver/updatePersonalData/${params.id}`, bodyUpdatePersonal);

      if (res.status === 200) {
        await getDriver('personal');
      }
    } catch (e) {
      snackbar.show(
        <Text>
          {e.response?.data[0]?.message || 'Algo deu errado, tente novamente mais tarde!'}
        </Text>,
        {
          type: 'error',
        },
      );
      setLoadPersonalEditing(false);
    }
  }

  function validateCnhData() {
    const err = {};

    // Número da CNH
    if (!cnhNumber) {
      err.cnhNumber = 'Campo obrigatório';
    } else if (!whiteSpace(cnhNumber)) {
      err.cnhNumber = 'Campo inválido';
    }

    // Categoria (obrigatório quando CNH não é estrangeira)
    if (!isCnhInternational && !cnhType) {
      err.cnhType = 'Campo obrigatório';
    }

    // Cidade de emissão da CNH (obrigatório quando nem motorista nem CNH são estrangeiros)
    if (!isInternational && !isCnhInternational && !cnhIssuingCity) {
      err.cnhIssuingCity = 'Campo obrigatório';
    }

    // 1ª habilitação
    if (!firstCnhDate) {
      err.firstCnhDate = 'Campo obrigatório';
    } else if (!validateDate(firstCnhDate)) {
      err.firstCnhDate = 'Data inválida';
    }

    // Data de emissão CNH
    if (!cnhDispatchDate) {
      err.cnhDispatchDate = 'Campo obrigatório';
    } else if (!validateDate(cnhDispatchDate)) {
      err.cnhDispatchDate = 'Data inválida';
    }

    // Validade da CNH
    if (!cnhDueDate) {
      err.cnhDueDate = 'Campo obrigatório';
    } else if (!validateFutureDate(cnhDueDate)) {
      err.cnhDueDate = 'CNH vencida';
    } else if (!expireDate(cnhDueDate, 10)) {
      err.cnhDueDate = 'Válidade máxima 10 anos';
    }

    if (hasMopp) {
      // Descrição do Mopp
      if (!moppDescription) {
        err.moppDescription = 'Campo obrigatório';
      } else if (!whiteSpace(moppDescription)) {
        err.moppDescription = 'Campo inválido';
      }

      // Validade do Mopp
      if (!moppDueDate) {
        err.moppDueDate = 'Campo obrigatório';
      } else if (!expireDate(moppDueDate, 5)) {
        err.moppDueDate = 'Válidade máxima 5 anos';
      }

      // Data do primeiro Mopp
      if (!moppInitialDate) {
        err.mopp_date_init = 'Campo obrigatório';
      } else if (!validateDate(moppInitialDate)) {
        err.mopp_date_init = 'Data inválida';
      }
    }

    setErrors(err);
    return !Object.keys(err).length;
  }

  async function uploadFile(cnhFile, driverId, side) {
    const data = new FormData();
    data.append('image_cnh', cnhFile);

    try {
      const response = await driverApi.post(`/driver/${driverId}/${side}`, data);

      return response.data;
    } catch (err) {
      return null;
    }
  }
  async function saveCnhData() {
    try {
      if (!validateCnhData()) {
        snackbar.show(<Text>Verifique os campos obrigatórios!</Text>, {
          type: 'error',
        });
        return;
      }
      setLoadCnhEditing(true);
      const bodyUpdateCnh = {
        cnh_number: cnhNumber,
        cnh_type: cnhType && cnhType.label,
        cnh_key: cnhKey,
        cnh_dispatch_city: cnhIssuingCity && cnhIssuingCity.id,
        cnh_dispatch_state: cnhIssuingCity && cnhIssuingCity.province.id,
        first_cnh_date: firstCnhDate
          ? moment(firstCnhDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
          : null,
        cnh_dispatch_date: cnhDispatchDate
          ? moment(cnhDispatchDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
          : null,
        cnh_exp_date: cnhDueDate ? moment(cnhDueDate, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
        mopp: hasMopp,
        mopp_description: hasMopp ? moppDescription : null,
        mopp_expiration: hasMopp ? moment(moppDueDate, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
        mopp_date_init: hasMopp ? moment(moppInitialDate, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
        exclusive: isExclusive,
        is_autonomous: isAutonomous,
        is_owner: isOwner,
        cnh_is_foreign: isCnhInternational,
      };

      const res = await api.put(`driver/updateCnh/${params.id}`, bodyUpdateCnh);

      if (frontImageCnh) {
        await uploadFile(frontImageCnh[0], params.id, 'front_cnh');
      }

      if (res.status === 200) {
        getDriver('cnh');
        setFrontImageCnh('');
      }
    } catch (e) {
      setLoadCnhEditing(false);
    }
  }

  async function saveContactData() {
    try {
      setLoadContactsEditing(true);

      const bodyUpdatePersonal = {
        phone_cooperplace: cooperplacePhone,
        phone_cooperplace_country_id: countryDDI?.id,
        email,
        others: otherContacts,
      };

      const res = await api.put(`driver/updateContacts/${params.id}`, bodyUpdatePersonal);

      if (res.status === 200) {
        getDriver('contact');
      }
    } catch (e) {
      setLoadContactsEditing(false);
    }
  }

  function validateAddressData() {
    const err = {};
    if (address) {
      if (address.length < 3) {
        err.address = 'É necessário pelo menos 3 caracteres.';
      }
    } else err.address = 'Insira um endereço.';

    if (!numberless) {
      if (number) {
        if (!/^\d+$/.test(number)) err.number = 'Insira apenas números.';
      } else err.number = 'Insira o número da rua.';
    }

    if (!neighborhood) err.neighborhood = 'Insira um bairro.';

    if (!cep) err.cep = 'Insira o CEP.';

    if (!city) err.city = 'Escolha uma cidade.';

    setErrors(err);
    return !Object.keys(err).length;
  }

  async function saveAddressData() {
    if (!validateAddressData()) return;

    try {
      setLoadAddressEditing(true);
      const bodyUpdateAddress = {
        address,
        number: !numberless ? number : null,
        complement,
        neighborhood,
        zip_code: cep,
        country_id: country?.id,
        uf_name: ufName,
        city,
        property_type: homeType && homeType?.label,
        property_status: addressType && addressType?.label,
      };

      await api.put(`driver/updateAddress/${params.id}`, bodyUpdateAddress);

      await getDriver('address');
      setAddressEditing(false);
    } catch (ex) {
      snackbar.show(<Text>Algo deu errado ao alterar o endereço</Text>, {
        type: 'error',
      });
    } finally {
      setLoadAddressEditing(false);
      getDriver('address');
    }
  }

  async function addContact() {
    const phone = otherPhone;
    const name = otherName;
    setOtherContacts([...otherContacts, { name, phone }]);
    setOtherName('');
    setOtherPhone('');
  }

  async function deleteContact(name) {
    const newOtherContacts = otherContacts.filter((x) => x.name !== name);
    setOtherContacts(newOtherContacts || []);
  }

  async function fetchCities(search) {
    try {
      const response = await api.get('cities', { params: { search } });
      return response.data;
    } catch (ex) {
      return [];
    }
  }

  async function getLastTravels() {
    try {
      const response = await api.get(`driver-history/${params.id}`);
      setLastTravels(response.data);
    } catch (error) {
      // Handle exception
    }
  }

  async function fetchRiskManagers() {
    try {
      const response = await api.get(`driver/${params.id}/risk-managers`);
      setRiskManagers(response.data);
    } catch (ex) {
      // Handle exception
    }
  }

  async function fetchTags(search) {
    try {
      const response = await api.get('tags', { params: { search } });
      return response.data.data;
    } catch (ex) {
      return [];
    }
  }

  function completAddress(place) {
    if (place) {
      const province = {
        name: place.province_name,
        uf: place.province,
      };

      if (place.city) {
        setCity({ name: place.city, province });
      }

      setUf(province.uf);
      setUfName(province.name);
      setAddress(place.address || '');
      setNeighborhood(place.neighborhood || '');
      setNumber(place.number || '');
      setNumberless(!place.number);
      setCep(place.zip_code || '');
      setComplement('');
    }
  }
  useEffect(() => {
    async function fetchProvinces() {
      try {
        const response = await api.get('provinces');
        setProvinces(response.data);
      } catch (ex) {
        // Handle exeception
      }
    }
    fetchProvinces();
  }, []);

  useEffect(() => {
    if (params.id) {
      getDriver();
      getLastTravels();
      fetchRiskManagers();
    }
  }, [params.id]);

  const [inputTag, setInputTag] = useState('');

  function tagTreatment(input) {
    if (input) {
      const inputFiltered = input.trimStart().replace(/[^a-zA-Z0-9 ]/g, '');
      setInputTag(inputFiltered);
    } else {
      setInputTag('');
    }
  }

  async function handleTagCreate(tagValue) {
    let outputTag = tagValue;
    if (tagRegisterPermitted) {
      if (outputTag) {
        outputTag = tagValue.trim();
        if (tagValue.length >= 3) {
          try {
            const response = await api.post('tags', { name: tagValue });
            if (response.status === 200) {
              const newTag = {
                id: response.data.id,
                name: tagValue,
              };
              setInputTag('');
              setSelectedTags(selectedTags ? [...selectedTags, newTag] : [newTag]);
            }
          } catch (err) {
            // Ignore exception
          }
        }
      }
    } else {
      snackbar.show(<Text>Usuário sem permissão para criar tags!</Text>, {
        type: 'error',
      });
    }
  }

  const isBrazilian = country?.abbreviation === 'br';

  useEffect(() => {
    if (
      !!driver?.mopp ||
      !!driver?.mopp_date_init ||
      !!driver?.mopp_description ||
      !!driver?.mopp_expiration
    ) {
      setHasMopp(true);
    }
  }, [driver, personalEditing]);

  useEffect(() => {
    if (params.id) {
      dispatch({
        type: 'VIEW_INSTANCE',
        instance: driver?.social_name,
      });
    }
  }, [driver]);

  return (
    <>
      <ApplicationLayout
        title="Detalhes do Motorista"
        RightComponent={
          <>
            <Space x="4px">
              <Button variant="secondary" onClick={() => navigate(-1)} className="ml-2">
                <Text weight={500} type="regular">
                  Voltar
                </Text>
              </Button>
              {hasPermissionToCreate && (
                <>
                  <Link to="/motoristas/cadastrar/ocr">
                    <Button variant="primary" className="py-2 mr-2" style={{ minHeight: 44 }}>
                      <Text weight={500} color="white" type="regular">
                        Novo Motorista
                      </Text>
                    </Button>
                  </Link>
                </>
              )}
            </Space>
          </>
        }
      >
        <Resume driver={driver} loading={loadingCard} />
        <RiskManagerModal
          isOpen={riskManagerModal.isOpen}
          onClose={riskManagerModal.close}
          driver={driver}
          riskManagers={riskManagers}
          fetchRiskManagers={fetchRiskManagers}
        />
        <RiskManagerLiberation
          isOpen={riskManagerLiberation.isOpen}
          onClose={riskManagerLiberation.close}
          riskManagers={riskManagers}
          setRiskManagers={setRiskManagers}
          driver={driver}
        />
        <Row>
          <Col xs={12}>
            <RegisterInfo loading={loadingCard} />
          </Col>

          <Col md={6} xs={12}>
            <Card
              loading={loadingCard}
              LoadingBodyComponent={() => (
                <DefaultLoadingBodyComponent linesCount={9} perLine={2} />
              )}
              header={
                <Text color="#464E5F" type="header">
                  Dados pessoais
                </Text>
              }
              HeaderRightComponent={
                <div style={{ display: 'flex', gap: 8 }}>
                  {personalEditing && (
                    <Button
                      onClick={() => setPersonalEditing(false)}
                      variant="secondary"
                      loading={loadPersonalEditing}
                    >
                      <Text color="dark" type="regular">
                        Cancelar
                      </Text>
                    </Button>
                  )}
                  <Button
                    variant={personalEditing ? 'success' : 'secondary'}
                    disabled={!hasPermissionToEdit}
                    loading={loadPersonalEditing}
                    onClick={personalEditing ? savePersonalData : () => setPersonalEditing(true)}
                  >
                    <Text weight={500} type="regular">
                      {personalEditing ? 'Salvar' : 'Editar'}
                    </Text>
                  </Button>
                </div>
              }
            >
              {personalEditing ? (
                <Row className="form">
                  <Col xs={12} className="mb-3">
                    <Radio.Group
                      label="Estrangeiro *"
                      onChange={({ target }) => setIsInternational(target.value)}
                      value={isInternational}
                      horizontal
                    >
                      <Radio value>
                        <Text color="dark" type="label">
                          Sim
                        </Text>
                      </Radio>
                      <Radio value={false}>
                        <Text color="dark" type="label">
                          Não
                        </Text>
                      </Radio>
                    </Radio.Group>
                  </Col>

                  <Col xs={12}>
                    <Input
                      label="Nome *"
                      type="text"
                      value={socialName}
                      onChange={(e) => setSocialName(e.target.value)}
                      error={errors.socialName}
                    />
                  </Col>

                  <Col lg={6} md={6} xs={12}>
                    <Input
                      value={cpf}
                      onChange={(e) => setCpf(e.target.value)}
                      label={isBrazilian ? 'CPF *' : 'Documento *'}
                      masked={!isInternational}
                      mask={CPF_MASK}
                      error={errors.cpf}
                    />
                  </Col>
                  <Col lg={6} md={6} xs={12}>
                    <DatePicker
                      guide
                      value={birthdate}
                      onChange={(e) => setBirthdate(e.target.value)}
                      label="Data de nascimento *"
                      error={errors.birthdate}
                    />
                  </Col>

                  <Col xs={12}>
                    <Select.Async
                      label="Cidade natal *"
                      onSearch={fetchCities}
                      value={birthCity}
                      onChange={value => setBirthCity(value)}
                      getOptionLabel={option =>
                        `${option.name}, ${option.province.uf}`
                      }
                      getOptionValue={option => option.id}
                      error={errors.birthCity}
                    />
                  </Col>

                  <Col lg={6} md={6} xs={12}>
                    <Input
                      value={rg}
                      onChange={(e) => setRg(e.target.value)}
                      label={`RG ${isInternational ? '' : '*'}`}
                      error={errors.rg}
                    />
                  </Col>
                  <Col lg={6} md={6} xs={12}>
                    <Input
                      label={`Órgão emissor / UF ${isInternational ? '' : '*'}`}
                      value={issuingBody}
                      onChange={(e) => setIssuingBody(e.target.value)}
                      error={errors.issuingBody}
                    />
                  </Col>

                  <Col lg={6} md={6} xs={12}>
                    <DatePicker
                      guide
                      value={issuingDate}
                      onChange={(e) => setIssuingDate(e.target.value)}
                      label="Data de emissão RG"
                      error={errors.issuingDate}
                    />
                  </Col>

                  <Col xs={12}>
                    <Input
                      label="Mãe *"
                      value={motherName}
                      onChange={(e) => setMotherName(e.target.value)}
                      error={errors.motherName}
                    />
                  </Col>
                  <Col xs={12}>
                    <Input
                      label="Pai *"
                      value={fatherName}
                      onChange={e => setFatherName(e.target.value)}
                      error={errors.fatherName}
                    />
                  </Col>

                  <Col lg={6} md={6} xs={12}>
                    <Select
                      label="Estado Civil *"
                      value={civilStatus}
                      onChange={(event) => {
                        setCivilStatus(event);
                      }}
                      options={CIVIL_STATUS}
                      getOptionValue={option => option.label}
                      error={errors.civilStatus}
                    />
                  </Col>

                  <Col lg={4} md={4} xs={12} className="mb-3">
                    <Radio.Group
                      label="Autônomo *"
                      onChange={({ target }) => setIsAutonomous(target.value)}
                      value={isAutonomous}
                      horizontal
                    >
                      <Radio value>
                        <Text color="dark" type="label">
                          Sim
                        </Text>
                      </Radio>
                      <Radio value={false}>
                        <Text color="dark" type="label">
                          Não
                        </Text>
                      </Radio>
                    </Radio.Group>
                  </Col>

                  <Col lg={6} md={6} xs={12}>
                    <Input
                      value={pis}
                      onChange={e => setPis(e.target.value)}
                      label={isAutonomous ? 'PIS *' : 'PIS'}
                      masked
                      mask={PIS_MASK}
                      error={errors.pis}
                    />
                  </Col>

                  <Col xs={12}>
                    <Select.Async
                      multiple
                      label="Tags"
                      onSearch={fetchTags}
                      value={selectedTags}
                      onChange={(value) => setSelectedTags(value)}
                      getOptionLabel={(option) => option.name}
                      getOptionValue={(option) => option.id}
                      onInputChange={(e) => tagTreatment(e)}
                      inputValue={inputTag}
                      onCreateOption={handleTagCreate}
                      creatable
                    />
                  </Col>
                </Row>
              ) : (
                <PersonalData driver={driver} isBrazilian={isBrazilian} />
              )}
            </Card>
            <Card
              loading={loadingCard}
              LoadingBodyComponent={() => (
                <DefaultLoadingBodyComponent linesCount={2} perLine={2} />
              )}
              header={
                <Text color="#464E5F" type="header">
                  Contatos
                </Text>
              }
              HeaderRightComponent={
                <div style={{ display: 'flex', gap: 8 }}>
                  {contactsEditing && (
                    <Button
                      onClick={() => setContactsEditing(false)}
                      variant="secondary"
                      loading={loadContactsEditing}
                    >
                      <Text color="dark" type="regular">
                        Cancelar
                      </Text>
                    </Button>
                  )}
                  <Button
                    variant={contactsEditing ? 'success' : 'secondary'}
                    disabled={!hasPermissionToEdit}
                    loading={loadContactsEditing}
                    onClick={contactsEditing ? saveContactData : () => setContactsEditing(true)}
                  >
                    <Text weight={500} type="regular">
                      {contactsEditing ? 'Salvar' : 'Editar'}
                    </Text>
                  </Button>
                </div>
              }
            >
              {contactsEditing ? (
                <Row className="form">
                  <Col xs={12}>
                    <Select
                      label="País (DDI)"
                      options={countriesDDI}
                      value={countryDDI}
                      onChange={(value) => {
                        setCooperplacePhone('');
                        setCountryDDI(value);
                      }}
                      getOptionLabel={(option) => option.name}
                      getOptionValue={(option) => option.id}
                      disableClear
                    />
                  </Col>
                  <Col lg={6} md={6} xs={12}>
                    <Input
                      value={mainPhone}
                      icon={<FaPhoneAlt color="#494950" />}
                      masked
                      mask={PHONE_MASK}
                      label="Telefone (benner)"
                      disabled
                    />
                  </Col>
                  <Col lg={6} md={6} xs={12}>
                    <Input
                      value={cooperplacePhone}
                      onChange={(e) => setCooperplacePhone(e.target.value)}
                      icon={<FaPhoneAlt color="#494950" />}
                      masked
                      mask={getPhoneMask(countryDDI?.abbreviation.toUpperCase())}
                      label="Telefone (cooperplace)"
                    />
                  </Col>
                  <Col xs={12}>
                    <Input
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      label="Email"
                      type="email"
                    />
                  </Col>
                  <Col xs={12} className="my-3">
                    <Text type="body" color="#464E5F">
                      Outros contatos
                    </Text>
                  </Col>
                  <Col xs={12}>
                    <Input
                      label="Nome"
                      value={otherName}
                      onChange={(e) => setOtherName(e.target.value)}
                    />
                  </Col>
                  <Col lg={6} md={6} xs={12}>
                    <Input
                      value={otherPhone}
                      onChange={(e) => setOtherPhone(e.target.value)}
                      icon={<FaPhoneAlt color="#494950" />}
                      masked
                      mask={PHONE_MASK}
                      label="Telefone"
                    />
                  </Col>
                  <Col lg={6} md={6} xs={12}>
                    <Button
                      variant="success"
                      onClick={() => addContact()}
                      style={{ marginTop: '30px' }}
                    >
                      <Text weight={600} type="regular">
                        Adicionar
                      </Text>
                    </Button>
                  </Col>
                  <Col xs={12} className="mt-3">
                    <Table>
                      <thead>
                        <tr>
                          <th>
                            <Text type="label" weight="500">
                              Nome
                            </Text>
                          </th>
                          <th className="text-center">
                            <Text type="label" weight="500">
                              Telefone
                            </Text>
                          </th>
                          <th className="text-center">
                            <Text type="label" weight="500">
                              Ação
                            </Text>
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {otherContacts &&
                          otherContacts.map((x) => (
                            <tr>
                              <td>
                                <Text type="regular" weight="400">
                                  {x.name}
                                </Text>
                              </td>
                              <td width="240" className="text-center">
                                <Text type="regular" weight="400">
                                  {x.phone}
                                </Text>
                              </td>
                              <td width="60" className="text-center">
                                <Button
                                  variant="error"
                                  size="sm"
                                  className="mx-1"
                                  onClick={() => deleteContact(x.name)}
                                >
                                  <FaTrash />
                                </Button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              ) : (
                <>
                  <ContactDetails driver={driver} />
                </>
              )}
            </Card>
            <UserData
              loadingCard={loadingCard}
              hasPermissionToEdit={hasPermissionToEdit}
              driver={driver}
              refetch={getDriver}
            />
            <Payment driver={driver} getDriver={getDriver} loadingCard={loadingCard} />
            <PaymentCards
              driver={driver}
              getDriver={getDriver}
              loadingCard={loadingCard}
              errors={errors}
            />
            <Verification loadingCard={loadingCard} />
          </Col>

          <Col lg={6} md={6} xs={12}>
            <Card
              loading={loadingCard}
              LoadingBodyComponent={() => (
                <DefaultLoadingBodyComponent linesCount={7} perLine={2} />
              )}
              header={
                <Text color="#464E5F" type="header">
                  CNH
                </Text>
              }
              HeaderRightComponent={
                <div style={{ display: 'flex', gap: 8 }}>
                  {cnhEditing && (
                    <Button
                      onClick={() => setCnhEditing(false)}
                      variant="secondary"
                      loading={loadCnhEditing}
                    >
                      <Text color="dark" type="regular">
                        Cancelar
                      </Text>
                    </Button>
                  )}
                  <Button
                    variant={cnhEditing ? 'success' : 'secondary'}
                    disabled={!hasPermissionToEdit}
                    loading={loadCnhEditing}
                    onClick={cnhEditing ? saveCnhData : () => setCnhEditing(true)}
                  >
                    <Text weight={500} type="regular">
                      {cnhEditing ? 'Salvar' : 'Editar'}
                    </Text>
                  </Button>
                </div>
              }
            >
              {cnhEditing ? (
                <Row className="form">
                  <Col xs={12} className="mb-3">
                    <Radio.Group
                      label="CNH Estrangeira *"
                      onChange={({ target }) => setIsCnhInternational(target.value)}
                      value={isCnhInternational}
                      horizontal
                    >
                      <Radio value>
                        <Text color="dark" type="label">
                          Sim
                        </Text>
                      </Radio>
                      <Radio value={false}>
                        <Text color="dark" type="label">
                          Não
                        </Text>
                      </Radio>
                    </Radio.Group>
                  </Col>

                  <Col lg={6} md={6} xs={12}>
                    <Input
                      label="CNH *"
                      value={cnhNumber}
                      onChange={(e) => setCnhNumber(e.target.value)}
                      error={errors.cnhNumber}
                    />
                  </Col>
                  <Col lg={6} md={6} xs={12}>
                    <Select
                      label="Categoria *"
                      value={cnhType}
                      onChange={value => setCnhType(value)}
                      options={CNH_TYPES}
                      getOptionValue={option => option.label}
                      error={errors.cnhType}
                    />
                  </Col>
                  <Col xs={12}>
                    <Input
                      label="Chave da CNH"
                      value={cnhKey}
                      onChange={(e) => setCnhKey(e.target.value)}
                    />
                  </Col>
                  <Col xs={12}>
                    <Select.Async
                      label="Cidade emissão CNH *"
                      onSearch={fetchCities}
                      value={cnhIssuingCity}
                      onChange={(value) => setCnhIssuingCity(value)}
                      getOptionLabel={(option) => `${option.name}, ${option.province.uf}`}
                      getOptionValue={(option) => option.id}
                      error={errors.cnhIssuingCity}
                    />
                  </Col>
                  <Col lg={6} md={6} xs={12}>
                    <DatePicker
                      guide
                      label="1° habilitação *"
                      value={firstCnhDate}
                      onChange={(e) => setFirstCnhDate(e.target.value)}
                      error={errors.firstCnhDate}
                    />
                  </Col>
                  <Col lg={6} md={6} xs={12}>
                    <DatePicker
                      guide
                      label="Data de emissão CNH *"
                      value={cnhDispatchDate}
                      onChange={(e) => setCnhDispatchDate(e.target.value)}
                      error={errors.cnhDispatchDate}
                    />
                  </Col>
                  <Col lg={6} md={6} xs={12}>
                    <DatePicker
                      guide
                      label="Validade habilitação *"
                      value={cnhDueDate}
                      onChange={(e) => setCnhDueDate(e.target.value)}
                      error={errors.cnhDueDate}
                    />
                  </Col>
                  <Col xs={12} className="mb-3">
                    <Radio.Group
                      label="Possui Mopp *"
                      onChange={({ target }) => setHasMopp(target.value)}
                      value={hasMopp}
                      horizontal
                    >
                      <Radio value>
                        <Text color="dark" type="label">
                          Sim
                        </Text>
                      </Radio>
                      <Radio value={false}>
                        <Text color="dark" type="label">
                          Não
                        </Text>
                      </Radio>
                    </Radio.Group>
                  </Col>

                  {hasMopp && (
                    <>
                      <Col xs={12}>
                        <Input
                          label="Descrição do Mopp *"
                          value={moppDescription}
                          onChange={(e) => setMoppDescription(e.target.value)}
                          error={errors.moppDescription}
                        />
                      </Col>
                      <Col lg={6} md={6} xs={12}>
                        <DatePicker
                          guide
                          label="Validade do Mopp *"
                          value={moppDueDate}
                          onChange={(e) => setMoppDueDate(e.target.value)}
                          error={errors.moppDueDate}
                        />
                      </Col>

                      <Col lg={6} md={6} xs={12}>
                        <Input
                          icon={<BsCalendar color="#464E5F" />}
                          label="Primeiro Mopp *"
                          value={moppInitialDate}
                          onChange={(e) => setMoppInitialDate(e.target.value)}
                          masked
                          mask={DATE_MASK}
                          error={errors.mopp_date_init}
                        />
                      </Col>
                    </>
                  )}

                  <Col lg={4} md={4} xs={12} className="mb-3">
                    <Radio.Group
                      label="Exclusivo *"
                      onChange={({ target }) => setIsExclusive(target.value)}
                      value={isExclusive}
                      horizontal
                    >
                      <Radio value>
                        <Text color="dark" type="label">
                          Sim
                        </Text>
                      </Radio>
                      <Radio value={false}>
                        <Text color="dark" type="label">
                          Não
                        </Text>
                      </Radio>
                    </Radio.Group>
                  </Col>
                  <Col lg={4} md={4} xs={12} className="mb-3">
                    <Radio.Group
                      label="Proprietário *"
                      onChange={({ target }) => setIsOwner(target.value)}
                      value={isOwner}
                      horizontal
                    >
                      <Radio value>
                        <Text color="dark" type="label">
                          Sim
                        </Text>
                      </Radio>
                      <Radio value={false}>
                        <Text color="dark" type="label">
                          Não
                        </Text>
                      </Radio>
                    </Radio.Group>
                  </Col>

                  <Col xs={12} className="mb-3">
                    <Text type="label" color="#464E5F">
                      Upload de CNH
                    </Text>

                    <Row>
                      <Col lg={6} md={6} xs={12} className="text-center mt-3">
                        <Text type="label" color="#464E5F">
                          Foto ou CNH Digital
                        </Text>
                        <Upload
                          sizeIcon={50}
                          icon={<FaImage size={50} />}
                          onChange={(event) => setFrontImageCnh(event.target.files)}
                          value={frontImageCnh}
                          id="imgFront"
                          name="driverFront"
                          accept={['.png', '.jpg', '.pdf']}
                          label="Arquivo máximo de 5MB"
                        />
                      </Col>
                      <Col xs={12} className="text-center mt-3">
                        <Text color="#464E5F" type="little">
                          Para manter as fotos atuais, deixe os campos em branco{' '}
                        </Text>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              ) : (
                <CnhData
                  driver={driver}
                  attachments={driverAttachments}
                />
              )}
            </Card>

            <Card
              loading={loadingCard}
              LoadingBodyComponent={() => (
                <DefaultLoadingBodyComponent linesCount={5} perLine={2} />
              )}
              header={
                <Text color="#464E5F" type="header">
                  Endereço
                </Text>
              }
              HeaderRightComponent={
                <div style={{ display: 'flex', gap: 8 }}>
                  {addressEditing && (
                    <Button
                      onClick={() => setAddressEditing(false)}
                      variant="secondary"
                      loading={loadAddressEditing}
                    >
                      <Text color="dark" type="regular">
                        Cancelar
                      </Text>
                    </Button>
                  )}
                  <Button
                    variant={addressEditing ? 'success' : 'secondary'}
                    disabled={!hasPermissionToEdit}
                    loading={loadAddressEditing}
                    onClick={addressEditing ? saveAddressData : () => setAddressEditing(true)}
                  >
                    <Text weight={500} type="regular">
                      {addressEditing ? 'Salvar' : 'Editar'}
                    </Text>
                  </Button>
                </div>
              }
            >
              {addressEditing ? (
                <Row className="form">
                  <Col xs={12}>
                    <Select
                      label="País"
                      options={countries}
                      value={country}
                      onChange={(value) => setCountry(value)}
                      getOptionLabel={(option) => option.name}
                      getOptionValue={(option) => option.id}
                      disableClear
                    />
                  </Col>
                  <Col xs={12}>
                    <InputAddress
                      name="origin"
                      label="Endereço"
                      country={country?.abbreviation || 'br'}
                      value={address}
                      onSelectedAddress={(place) => completAddress(place)}
                      onChange={(event) => setAddress(event.target.value)}
                      types={[]}
                      placeholder=""
                      error={errors.address}
                    />
                  </Col>
                  <Col lg={6} md={6} xs={12}>
                    <Input
                      disabled={numberless}
                      label={numberless ? 'Número' : 'Número *'}
                      value={number}
                      onChange={(e) => setNumber(e.target.value)}
                      error={errors.number}
                    />
                  </Col>
                  <Col lg={6} md={6} xs={12} className="d-flex align-items-center">
                    <Radio.Group
                      onChange={() => setNumberless((old) => !old)}
                      value={numberless}
                      horizontal
                    >
                      <Radio value={false}>
                        <Text color="dark" type="label">
                          Com Nº
                        </Text>
                      </Radio>
                      <Radio value>
                        <Text color="dark" type="label">
                          Sem Nº
                        </Text>
                      </Radio>
                    </Radio.Group>
                  </Col>
                  <Col lg={6} md={6} xs={12}>
                    <Input
                      label="Complemento"
                      value={complement}
                      onChange={(e) => setComplement(e.target.value)}
                    />
                  </Col>
                  <Col lg={6} md={6} xs={12}>
                    <Input
                      label="Bairro *"
                      value={neighborhood}
                      onChange={(e) => setNeighborhood(e.target.value)}
                      error={errors.neighborhood}
                    />
                  </Col>
                  <Col lg={6} md={6} xs={12}>
                    <Input
                      label="CEP *"
                      value={cep}
                      onChange={(e) => setCep(e.target.value)}
                      error={errors.cep}
                    />
                  </Col>
                  <Col xs={12}>
                    <Select.Async
                      label="Cidade *"
                      onSearch={fetchCities}
                      value={city}
                      onChange={(value) => {
                        setUfName(value?.province?.uf);
                        setCity(value);
                      }}
                      getOptionLabel={(option) => `${option.name}, ${option.province?.uf}`}
                      getOptionValue={(option) => option.id}
                      error={errors.city}
                    />
                  </Col>
                  <Col lg={6} md={6} xs={12}>
                    <Select
                      label="Tipo de Moradia"
                      value={homeType}
                      onChange={(event) => {
                        setHomeType(event);
                      }}
                      options={HOME_TYPES}
                      getOptionValue={option => option.label}
                    />
                  </Col>
                  <Col lg={6} md={6} xs={12}>
                    <Select
                      label="Tipo de Endereço"
                      value={addressType}
                      onChange={(event) => {
                        setAddressType(event);
                      }}
                      options={ADDRESS_TYPES}
                      getOptionValue={option => option.label}
                    />
                  </Col>
                </Row>
              ) : (
                <AddressData driver={driver} country_name={country?.name} />
              )}
            </Card>

            <EmergencyContact
              driver={driver}
              getDriver={getDriver}
              loadingCard={loadingCard}
              errors={errors}
            />
            <Card
              loading={loadingCard}
              LoadingBodyComponent={() => (
                <DefaultLoadingBodyComponent linesCount={2} perLine={2} />
              )}
              header={
                <Text color="#464E5F" type="header">
                  Dispositivo com APP
                </Text>
              }
            >
              <Device
                device={{
                  version: driver && driver.device_app_version,
                  model: driver && driver.device_model,
                  system: driver && driver.device_os,
                  location: driver && driver.device_permission_location,
                  background: driver && driver.device_permission_background,
                  energy: driver && driver.device_economy_energy_disabled,
                }}
              />
            </Card>
            <Card
              loading={loadingCard}
              LoadingBodyComponent={() => (
                <DefaultLoadingBodyComponent linesCount={2} perLine={2} />
              )}
              header={
                <Text color="#464E5F" type="header">
                  Validação Benner
                </Text>
              }
            >
              {driver?.driver?.has_problems_benner !== null ? (
                <Row>
                  <Col xs={6}>
                    <Text type="label" color="dark">
                      Status da Importação
                    </Text>
                    <Text type="regular" color="gray" as="p" className="mt-2">
                      {' '}
                      {driver?.driver?.has_problems_benner
                        ? 'Com problemas'
                        : 'Cadastro sem problemas'}
                    </Text>
                  </Col>
                  <Col xs={6}>
                    <Text type="label" color="dark">
                      Data da última importação
                    </Text>

                    <Text type="regular" color="gray" as="p" className="mt-2">
                      {' '}
                      {formatDateTime(driver?.driver?.updated_at_status_benner) || 'Não informado'}
                    </Text>
                  </Col>
                  {driver?.driver?.has_problems_benner && (
                    <Col xs={12}>
                      <Text type="label" color="dark">
                        Descrição
                      </Text>

                      <Text type="regular" color="gray" as="p" className="mt-2">
                        {' '}
                        {driver?.driver?.description_status_benner || 'Não informado'}
                      </Text>
                    </Col>
                  )}
                </Row>
              ) : (
                <Col xs={12}>
                  <Text type="regular" color="gray" as="p" className="mt-2">
                    Motorista não importado do Benner
                  </Text>
                </Col>
              )}
            </Card>
          </Col>
          <Col xs={12}>
            <Card
              loading={loadingCard}
              LoadingBodyComponent={() => (
                <DefaultLoadingBodyComponent linesCount={2} perLine={2} />
              )}
              header={
                <Text color="#464E5F" type="header">
                  Manuais e Termos
                </Text>
              }
            >
              <DataTable
                withPagination={false}
                withFilterOption={false}
                data={driver?.acceptances || []}
                tableStyles={{
                  borderCollapse: 'collapse',
                  '> thead > tr > th': {
                    borderBottom: '2px solid #c5ccd5',
                  },
                  '> tbody > tr': {
                    borderBottom: '1px solid #d8dee6',
                  },
                  '> tbody > tr:hover': {
                    background: '#f3f6fa',
                  },
                  '> tbody > tr:hover > td': {
                    background: '#f3f6fa',
                  },
                }}
                columns={[
                  {
                    name: 'Termo',
                    selector: (row) => {
                      return row?.active ? `${row?.title}(atual)` : row?.title || 'Não informado';
                    },
                  },
                  {
                    name: 'Versão',
                    selector: row => {
                      if (row?.version == null) return 'Não informado';

                      const versionNumber = Number(row.version);
                      if (!Number.isFinite(versionNumber)) return 'Não informado';

                      return `V ${versionNumber.toFixed(2)}`;
                    },
                  },
                  {
                    name: 'Aceito em',
                    selector: (row) => {
                      return formatDateTime(row?.accepted_at) === 'Não informado'
                        ? 'Não aceito'
                        : formatDateTime(row?.accepted_at);
                    },
                  },
                  {
                    name: 'Localização',
                    selector: (row) => {
                      return (
                        row?.latitude &&
                        row?.longitude && (
                          <Text>
                            <a
                              href={`https://www.google.com/maps/search/?api=1&query=${row?.latitude},${row?.longitude}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <Button>
                                <FaMapMarkedAlt size="22" />
                              </Button>
                            </a>
                          </Text>
                        )
                      );
                    },
                  },
                ]}
              />
            </Card>
          </Col>
          <Col xs={12}>
            <Vehicles vehicles={vehicles} setVehicles={setVehicles} isLoading={loadingCard} />
          </Col>
          {whatsAppLogs.length > 0 && (
            <Col xs={12}>
              <Card
                loading={loadingCard}
                LoadingBodyComponent={() => (
                  <DefaultLoadingBodyComponent linesCount={1} perLine={2} />
                )}
                header={
                  <Text color="#464E5F" type="header">
                    Logs do whatsApp
                  </Text>
                }
              >
                <DataTable
                  data={whatsAppLogs || []}
                  loading={loadingCard}
                  withFilterOption={false}
                  page={1}
                  pages={1}
                  total={5}
                  defaultPerPage={5}
                  withPagination={false}
                  columns={[
                    {
                      name: 'ID Log',
                      selector: (row) => row?.id || '-',
                    },
                    {
                      name: 'Enviado por',
                      selector: (row) => row?.user?.username || '-',
                    },
                    {
                      name: 'Motorista',
                      selector: (row) => row?.person?.socialName || '-',
                    },
                    {
                      name: 'Telefone',
                      selector: (row) => row?.phonenumber || '-',
                    },
                    {
                      name: 'Tipo do Log',
                      selector: (row) => row?.whatsAppTypes?.description || '-',
                    },
                    {
                      name: 'ID',
                      selector: (row) => row?.relatedLoad?.id || row?.aggregationId,
                    },
                    {
                      name: 'Data',
                      selector: (row) => formatDateTime(row?.created_at) || '-',
                    },
                    {
                      name: 'status',
                      selector: (row) => (row?.status == 1 ? 'Enviado' : 'Não enviado'),
                    },
                  ]}
                />
              </Card>
            </Col>
          )}
          <Col xs={12}>
            <Card
              loading={loadingCard}
              LoadingBodyComponent={() => (
                <DefaultLoadingBodyComponent linesCount={1} perLine={2} />
              )}
              header={
                <Text color="#464E5F" type="header">
                  Últimas viagens
                </Text>
              }
              HeaderRightComponent={
                <>
                  {lastTravels && lastTravels.length > 0 && (
                    <Link
                      to={`/viagens?driver_name=${driver?.social_name}&driver_id=${driver?.id}&start_date=2019-01-01&tags=null`}
                    >
                      <Tooltip
                        content={
                          <Text type="label">
                            Ver todas as viagens desse motorista com a Coopertech
                          </Text>
                        }
                      >
                        <Button className="mr-2" href="">
                          <Text color="white" type="regular" weight="500">
                            Ver todas as viagens
                          </Text>
                        </Button>
                      </Tooltip>
                    </Link>
                  )}
                </>
              }
            >
              <Row>
                {lastTravels && lastTravels.length > 0 ? (
                  <Col xs={12}>
                    <LastTravels lastTravels={lastTravels} />
                  </Col>
                ) : (
                  <Col xs={12}>
                    <Text type="regular">Nenhuma viagem</Text>
                  </Col>
                )}
              </Row>
            </Card>
          </Col>
          <Col xs={12}>
            <Card
              loading={loadingCard}
              LoadingBodyComponent={() => (
                <DefaultLoadingBodyComponent linesCount={1} perLine={2} />
              )}
              header={
                <Text color="#464E5F" type="header">
                  Últimas consultas
                </Text>
              }
              HeaderRightComponent={
                <div style={{ display: 'flex', gap: 8 }}>
                  <Button
                    className="py-2"
                    onClick={() => {
                      riskManagerLiberation.open();
                    }}
                    variant="success"
                  >
                    <Text type="regular" weight="500">
                      Nova liberação
                    </Text>
                  </Button>
                  <Button
                    className="py-2"
                    onClick={() => {
                      riskManagerModal.open();
                    }}
                  >
                    <Text type="regular" weight="500">
                      Nova consulta
                    </Text>
                  </Button>
                </div>
              }
            >
              <Row>
                <Col xs={12}>
                  {riskManagers && riskManagers.length > 0 ? (
                    <RiskManager riskManagers={riskManagers} setRiskManagers={setRiskManagers} />
                  ) : (
                    <Text type="regular">
                      Nenhuma gerenciadora de risco cadastrada nesse motorista
                    </Text>
                  )}
                </Col>
              </Row>
            </Card>
          </Col>
          <Col xs={12}>
            <Card
              loading={loadingCard}
              LoadingBodyComponent={() => (
                <DefaultLoadingBodyComponent linesCount={2} perLine={2} />
              )}
              header={
                <Text color="#464E5F" type="header">
                  Jornada de trabalho
                </Text>
              }
            >
              <Row>
                <Col xs={12}>
                  <WorkJourney {...driver} />
                </Col>
              </Row>
            </Card>
          </Col>

          <Col xs={12}>
            <Attachments
              attachments={attachments}
              setAttachments={setAttachments}
              fetchAttachments={fetchAttachments}
              loading={attachLoading}
              setLoading={setAttachLoading}
            />
          </Col>
        </Row>
      </ApplicationLayout>
    </>
  );
}
